import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const StageEditItemNotesModal = ({ apiUrl, item, onClose, onSaved }) => {
  const [notes, setNotes] = useState(item?.notes || '');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!item?.id) return;

    setSaving(true);
    try {
      const res = await axios.post(
        `${apiUrl}/inventory_crud.php`,
        { status: 'updateStagingItem', data: { id: Number(item.id), notes: notes?.trim() || null } },
        { headers: { 'Content-Type': 'application/json' } }
      );
      const ok = (res.data && res.data.success === true) || (Array.isArray(res.data) && res.data[0] === 'success');

      if (ok) {
        toast.success('Notes updated');
        onSaved?.();
        onClose();
      } else {
        toast.error(res.data?.error || 'Failed to update notes');
      }
    } catch (e2) {
      if (e2?.response?.status === 401) {
        toast.error('Session expired. Please login again.', { position: 'top-center' });
      } else {
        toast.error('API error updating notes');
      }
    } finally {
      setSaving(false);
    }
  };

  if (!item) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white w-full max-w-lg rounded-lg shadow-lg">
        <div className="px-5 py-4 border-b flex items-center justify-between">
          <h2 className="text-lg font-semibold">Edit Notes — Item #{item.id}</h2>
          <button className="text-gray-500 hover:text-gray-700" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={submit} className="p-5 space-y-4">
          <div className="text-sm bg-gray-50 border rounded p-3">
            <div><span className="text-gray-500">Device:</span> <strong>{item.device_name || `#${item.device_id}`}</strong></div>
            {item.description && <div className="text-gray-500">{item.description}</div>}
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Notes</label>
            <textarea
              rows={5}
              className="w-full border rounded px-3 py-2"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </div>

          <div className="flex items-center justify-end gap-2 pt-2">
            <button type="button" className="px-4 py-2 rounded border" onClick={onClose} disabled={saving}>
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded disabled:opacity-60"
              disabled={saving}
            >
              {saving ? 'Saving…' : 'Save Notes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StageEditItemNotesModal;
